/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where a surface is served. A surface may have several at once.
 * @export
 */
export const DistributionChannel = {
    DIRECTORY: 'DIRECTORY',
    PLATFORM_URL: 'PLATFORM_URL',
    CUSTOM_DOMAIN: 'CUSTOM_DOMAIN'
} as const;
export type DistributionChannel = typeof DistributionChannel[keyof typeof DistributionChannel];


export function instanceOfDistributionChannel(value: any): boolean {
    for (const key in DistributionChannel) {
        if (Object.prototype.hasOwnProperty.call(DistributionChannel, key)) {
            if (DistributionChannel[key as keyof typeof DistributionChannel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DistributionChannelFromJSON(json: any): DistributionChannel {
    return DistributionChannelFromJSONTyped(json, false);
}

export function DistributionChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionChannel {
    return json as DistributionChannel;
}

export function DistributionChannelToJSON(value?: DistributionChannel | null): any {
    return value as any;
}

export function DistributionChannelToJSONTyped(value: any, ignoreDiscriminator: boolean): DistributionChannel {
    return value as DistributionChannel;
}

